import millify from "millify";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import dbFirebase from "../firebase";
import { rxDB } from "../redux";
import "./CategoriesSummaryCard.css";

const CategoriesSummaryCard = ({ catgry }) => {
  const [filterToggle, setFilterToggle] = useState(false);
  const dispatch = useDispatch();

  const [fbData, setFbData] = useState([]);

  useEffect(() => {
    dbFirebase.collection("expenses").onSnapshot((snapshot) => {
      setFbData(snapshot.docs.map((doc) => doc.data()));
    });
  }, []);

  // const expenseList = useSelector((state) => state.expenseList);
  const categoryFIlterString = useSelector((state) => state.categoryFilter);
  const categoryFilterToggle = useSelector(
    (state) => state.categoryFilterToggle
  );

  const boxShodow =
    categoryFIlterString === catgry.title && categoryFilterToggle
      ? "0px 1px 5px 1px rgba(0,0,0,0.35)"
      : "none";

  const filerByCategory = () => {
    setFilterToggle(!filterToggle);
    dispatch(rxDB.sortByCategoryFilter(catgry.title));
    dispatch(rxDB.flipCategoryFilterToggle(catgry.title));
  };

  const categoryWiseTotalAmount =
    fbData.length > 0
      ? fbData.reduce((acc, item) => {
          if (item.category === catgry.title) {
            acc += +item.amount;
          }
          return acc;
        }, 0)
      : "0";

  return (
    <div
      onClick={filerByCategory}
      className="categoriesSummaryCard"
      style={{
        borderRight: `10px solid ${catgry.color}`,
        backgroundColor: `${catgry.color}40`,
        boxShadow: `${boxShodow}`,
      }}
    >
      <div className="card__leftViewSummary">
        <img className="lvs__img" src={catgry.icon} alt={catgry.title} />
      </div>

      <div className="card__rightViewSummary">
        <div className="rightView__title">{catgry.title}</div>
        <div className="rightView__AmountTotal">
          ₹{" "}
          {millify(categoryWiseTotalAmount, {
            precision: 1,
          })}
        </div>
      </div>
    </div>
  );
};

export default CategoriesSummaryCard;
